export const NUMBER_MIN = 'numberMin';
export const NUMBER_MAX = 'numberMax';

export const DATE_OPTION = 'dateOption';
export const DATE_OPTION_DURATION = 'duration';
export const DATE_OPTION_DATES = 'dates';
export const DATE_MAX = 'dateMax';
export const DATE_MIN = 'dateMin';
export const DATE_DURATION_VALUE = 'dateDurationValue';
export const DATE_DURATION_UNIT = 'dateDurationUnit';
export const DATE_DURATION_UNIT_DAYS = 'days';
export const DATE_DURATION_UNIT_MONTHS = 'months';

export const TIME_MAX = 'timeMax';
export const TIME_MIN = 'timeMin';

export const USE_BROWSER_TIME = 'useBrowserTime';
